import { asyncApi } from "@/services/apiService";

const _baseEndpoint = `${process.env.VUE_APP_BASE_API}/api/common/Geocodings`;

const geocodeService = {
  reverse: async (point, onBeginCallback, onFinallyCallback) => {
    return asyncApi.get(
      `${_baseEndpoint}/reverse?point=${point.lat}|${point.lng}`,
      onBeginCallback,
      onFinallyCallback
    );
  }
};
export default geocodeService;



// WEBPACK FOOTER //
// ./src/services/util/geocodeService.js